<template>
  <div class="member-filter-section">
    <div class="mb-2">
      <b-form-radio
        :checked="memberFilter"
        value="groupTag"
        @change="$emit('update:memberFilter', $event)">
        グループとタグで抽出
      </b-form-radio>
    </div>
    <div
      v-if="memberFilter === 'groupTag'"
      class="member-filter-section__filter-row mb-3 ml-4"
      data-testid="group-filter-select">
      <div class="member-filter-section__filter-item">
        <div class="fs-s mb-1">
          グループ
        </div>
        <MultiSelectList
          :value="selectedDepartmentIds"
          :options="departmentOptions"
          min-height="139px"
          aria-label="グループ"
          @input="$emit('update:selectedDepartmentIds', $event)" />
      </div>
      <div class="member-filter-section__filter-item">
        <div class="fs-s mb-1">
          #タグ1
        </div>
        <MultiSelectList
          :value="selectedTag1Values"
          :options="tag1Options"
          aria-label="#タグ1"
          @input="$emit('update:selectedTag1Values', $event)" />
      </div>
      <div class="member-filter-section__filter-item">
        <div class="fs-s mb-1">
          #タグ2
        </div>
        <MultiSelectList
          :value="selectedTag2Values"
          :options="tag2Options"
          aria-label="#タグ2"
          @input="$emit('update:selectedTag2Values', $event)" />
      </div>
    </div>

    <template v-if="studentNumberOption">
      <div class="mb-2">
        <b-form-radio
          :checked="memberFilter"
          value="gradeHomeroom"
          @change="$emit('update:memberFilter', $event)">
          学年と組で抽出
        </b-form-radio>
      </div>
      <div
        v-if="memberFilter === 'gradeHomeroom'"
        class="member-filter-section__filter-row mb-3 ml-4">
        <div class="member-filter-section__filter-item">
          <div class="fs-s mb-1">
            学年
          </div>
          <MultiSelectList
            :value="selectedGrades"
            :options="gradeOptions"
            aria-label="学年"
            @input="$emit('update:selectedGrades', $event)" />
        </div>
        <div class="member-filter-section__filter-item">
          <div class="fs-s mb-1">
            組
          </div>
          <MultiSelectList
            :value="selectedHomeroomValues"
            :options="homeroomOptions"
            aria-label="組"
            @input="$emit('update:selectedHomeroomValues', $event)" />
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { tag1SelectableOptions, tag2SelectableOptions } from '@/helper/tag'
import { gradeOptions, homeroomOptions } from '@/helper/studentNumber'
import MultiSelectList from '@/components/parts/MultiSelectList.vue'

export default {
  name: 'MemberFilterSection',
  components: { MultiSelectList },
  props: {
    memberFilter: { default: null, validator: v => v === null || typeof v === 'string' },
    selectedDepartmentIds: { type: Array, default: () => [] },
    selectedTag1Values: { type: Array, default: () => [] },
    selectedTag2Values: { type: Array, default: () => [] },
    selectedGrades: { type: Array, default: () => [] },
    selectedHomeroomValues: { type: Array, default: () => [] },
    departmentOptions: { type: Array, required: true },
  },
  computed: {
    ...mapGetters('tenant', ['studentNumberOption']),
    tag1Options() {
      return tag1SelectableOptions
    },
    tag2Options() {
      return tag2SelectableOptions
    },
    gradeOptions() {
      return gradeOptions.filter(o => o.value !== null)
    },
    homeroomOptions() {
      return homeroomOptions.filter(o => o.value !== null)
    },
  },
}
</script>

<style lang="scss" scoped>
.member-filter-section {
  &__filter-row {
    display: flex;
    gap: 16px;
    flex-wrap: wrap;
  }

  &__filter-item {
    flex: 1;
    min-width: 120px;
  }
}
</style>
